import React from 'react';

import { navigateTop } from '../routing/router-utils';
import { getOptimizedAsset, DispensaryAsset } from './dispensary-utils';
import { trackEvent } from '../analytics/tracking';
import comingSoon from '../../assets/deliveryComingSoon.png';
import PropTypes from 'prop-types';

import styles from './DispensaryCardTall.module.css';

const DispensaryCardTall = (
{
  dispensaryId,
  dispensaryName,
  dispensaryLogo,
  createDate, /* time stamp in SECONDS */
  dispensaryLocation={},
  travelDistance,
  isPickup
}) => {

  // Show NEW label for dispensaries created in the last 90 days
  const DAY_SECS = 86400;
  const NEW_LABEL_EXPIRY_SECS = 90 * DAY_SECS;
  const nowRef = React.useRef(parseInt(new Date().getTime()/1000, 10));
  const [isNewDispensary, setIsNewDispensary] = React.useState();

  const serviceLabel = isPickup ? 'Pickup' : 'Delivery';

  const optimizedLogo = getOptimizedAsset(dispensaryLogo, DispensaryAsset.LOGO);
  
  React.useEffect(() => {
    if (nowRef.current - NEW_LABEL_EXPIRY_SECS < createDate) {
      setIsNewDispensary(true);
    }  
  }, [NEW_LABEL_EXPIRY_SECS, createDate]);

  const shopDispensary = () => {
    trackEvent('dispensary_card_click', 'card', dispensaryId);
    // TODO: / FIXME: switchDispensary kills the back navigation
    navigateTop(`/switchDispensary/${dispensaryId}`);
  };

  return (
    <div className={styles.card} onClick={shopDispensary}>
      { isNewDispensary &&
        <div className={styles.newStorePill}>NEW!</div>
      }
      <div className={styles.logoWrap}>
        <img alt={dispensaryName} className={styles.dispLogo} src={optimizedLogo} />  
      </div>
      <div className={styles.detailsCol}>
        <div className={styles.dispName}>{dispensaryName}</div>
        <div className={styles.dispCity}>
          <span>
            {dispensaryLocation.city}&nbsp;&middot;{' '}{serviceLabel}
          </span>
        </div>
        <div className={styles.distance}>
          {' '}{travelDistance}
        </div>
      </div>
      <div className={styles.comingSoonWrap}>
        <div className={styles.comingSoon}>
          <img alt="Delivery Coming Soon" className={styles.comingSoonImg} src={comingSoon} />
        </div>
      </div>    
    </div>
  );
}

DispensaryCardTall.propTypes = {
  dispensaryId: PropTypes.string.isRequired,
  dispensaryName: PropTypes.string.isRequired,
  dispensaryLogo: PropTypes.string.isRequired,
  createDate: PropTypes.number.isRequired,
  dispensaryLocation: PropTypes.object.isRequired,
  travelDistance: PropTypes.string
}

export default DispensaryCardTall;
